var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrbit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 482,
    height: 485,
    viewBox: "0 0 482 485",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_234_2034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.106 72.3775C312.171 95.1422 303.895 122.194 281.925 133.832C257.197 146.899 235.329 136.69 221.535 118.315C203.959 94.6318 209.273 36.0357 270.481 16.2314C279.268 19.294 294.289 36.7503 298.581 44.4066C303.384 52.9816 307.778 62.4754 309.106 72.3775Z",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.696 61.3525C220.512 78.8089 228.278 106.167 216.016 127.809C202.222 152.207 178.311 155.372 156.852 147.307C129.262 136.895 101.979 84.6276 142.853 35.0149C151.947 32.8712 174.019 39.4045 181.683 43.59C190.47 48.1837 199.258 53.7983 205.696 61.3525Z",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.853 34.9127C142.955 34.8106 143.057 34.7086 143.16 34.5044",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.874 33.7898C161.347 15.3127 178.616 5.81888 201.812 1.93969C230.832 -2.96033 254.437 5.71679 269.56 15.6189",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.969 15.9253C270.071 16.0274 270.276 16.1295 270.378 16.2315",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.162 424.669C208.965 403.639 209.374 375.362 227.256 358.008C247.386 338.612 271.297 342.389 289.588 356.272C313.09 374.137 324.228 432.019 270.889 467.85C261.59 467.34 242.277 454.681 236.146 448.556C228.993 441.717 222.147 433.754 218.162 424.669Z",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.55 406.702C301.442 393.941 286.421 369.952 292.245 345.758C298.683 318.501 320.857 308.803 343.746 310.641C373.175 312.989 413.844 355.66 388.298 414.664C380.123 419.258 357.132 419.054 348.651 417.216C338.841 415.073 328.725 412.214 320.55 406.702Z",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.298 414.664C388.195 414.766 388.195 414.971 388.093 415.073",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.582 416.094C375.933 438.756 361.934 452.537 340.679 462.746C320.754 472.342 295.616 475.2 272.932 469.075",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.421 468.871C272.217 468.871 272.115 468.769 271.91 468.769",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7627 300.637C78.8858 283.385 104.738 271.645 127.934 280.526C154.093 290.53 160.837 313.703 156.034 336.06C149.801 364.847 102.184 399.556 47.0045 366.583C43.5303 357.906 46.698 335.141 49.6613 326.974C53.0334 317.685 57.2229 308.089 63.7627 300.637Z",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.642 385.468C127.014 362.806 142.444 339.02 166.866 333.916C194.251 328.199 212.439 344.022 220.512 365.562C230.832 393.125 209.578 448.046 145.203 450.087C137.539 444.677 127.934 423.75 125.992 415.277C123.744 405.579 122.211 395.268 123.642 385.468Z",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.202 450.189C144.998 450.189 144.896 450.189 144.691 450.189",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.67 450.087C118.226 449.169 99.7312 442.431 81.4403 427.527C63.9669 413.337 50.4787 391.185 46.5957 367.706",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5956 367.195C46.5956 366.991 46.4932 366.889 46.4932 366.685",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.613 463.767C276.51 463.869 276.306 463.971 276.203 464.073",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.385 464.685C255.153 480.712 227.768 487.042 204.572 483.469C177.596 479.283 158.487 466.727 145.306 451.312",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145 450.904C144.897 450.802 144.795 450.598 144.692 450.496",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5953 195.797C82.6669 189.672 110.767 194.061 125.277 214.172C141.729 236.834 134.576 259.905 118.227 276.034C97.177 296.757 38.3192 299.616 10.2188 241.734C12.0581 232.547 27.2834 215.295 34.2319 210.088C42.2022 204.167 50.99 198.451 60.5953 195.797Z",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4947 365.46C46.3923 365.358 46.1874 365.256 46.085 365.154",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2677 364.541C24.5245 349.841 12.7733 334.018 5.62049 311.56C-1.22581 290.02 -0.306162 264.193 9.40128 242.449",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.60547 242.041C9.7079 241.837 9.7079 241.734 9.81033 241.53",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.034 138.221C380.123 158.944 358.358 177.115 333.629 174.87C305.733 172.317 292.96 151.799 291.632 128.932C289.792 99.5317 326.374 53.2877 388.502 70.1316C394.224 77.4816 397.187 100.348 396.574 109.025C395.859 118.928 394.326 129.238 390.034 138.221Z",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.298 16.1292C271.502 16.1292 271.604 16.0271 271.809 16.0271",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.83 15.7209C297.559 9.69799 317.178 11.3313 338.738 20.723C359.073 29.6043 377.67 46.7544 387.787 67.7837",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.094 68.2939C388.196 68.4981 388.196 68.6002 388.299 68.8044",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.881 336.06C373.89 335.856 348.139 324.014 339.658 300.637C330.053 274.299 343.235 254.087 363.365 243.062C389.217 228.872 446.644 242.245 457.782 305.639C453.491 313.908 434.178 326.362 426.003 329.527C416.807 333.099 406.793 336.162 396.881 336.06Z",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.018 235.405C402.604 247.655 374.503 251.534 354.679 236.426C332.403 219.378 332.608 195.286 343.541 175.176C357.643 149.349 413.231 129.544 456.863 176.911C457.783 186.201 448.177 207.128 442.966 214.172C437.244 222.134 430.397 230.097 422.018 235.405Z",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.965 176.809C457.067 176.911 457.17 177.115 457.272 177.217",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.986 178.034C473.927 197.838 480.875 216.316 481.489 239.795C482.102 262.764 473.927 287.774 458.088 306.149",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.68 306.558C457.578 306.66 457.475 306.864 457.373 306.966",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.451 68.4983C381.656 68.4983 381.758 68.6004 381.962 68.6004",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.983 68.8044C408.325 73.7045 431.01 90.242 443.476 110.148C457.884 133.219 460.847 155.882 457.782 175.992",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.681 176.503C457.681 176.707 457.578 176.809 457.578 177.013",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.271 306.762C457.271 306.966 457.271 307.068 457.374 307.272",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.374 308.293C459.826 333.61 455.432 352.802 443.068 372.81C431.419 391.695 411.8 407.62 389.422 414.664",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.115 414.868C388.911 414.868 388.809 414.97 388.604 414.97",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.811 107.903C134.78 114.436 156.239 133.117 157.772 157.924C159.611 185.895 141.32 201.615 118.84 206.515C90.0241 212.845 38.6258 184.057 45.6764 120.153C52.114 113.415 74.1856 106.882 82.8712 106.065C92.783 105.146 103.308 105.044 112.811 107.903Z",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6758 120.05C45.6758 119.846 45.7782 119.744 45.7782 119.54",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8799 118.519C50.376 93.5087 59.7769 76.1544 77.0459 60.2294C93.804 44.8147 117.817 34.6063 141.83 34.198",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.342 34.198C142.546 34.198 142.648 34.198 142.853 34.198",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.116 241.836C10.0136 241.734 10.0136 241.53 9.91113 241.428",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50275 240.509C-0.51124 219.378 -1.94181 194.47 4.29139 174.155C12.2617 148.124 27.2827 130.973 44.5517 120.153",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9609 119.744C45.0634 119.642 45.2682 119.54 45.3707 119.438",
    stroke: "#33AF7C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.518 282.67C264.236 282.67 284.275 262.651 284.275 237.957C284.275 213.263 264.236 193.245 239.518 193.245C214.8 193.245 194.762 213.263 194.762 237.957C194.762 262.651 214.8 282.67 239.518 282.67Z",
    fill: "#0B5364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.796 126.89C359.938 126.89 367.35 119.486 367.35 110.353C367.35 101.219 359.938 93.8149 350.796 93.8149C341.654 93.8149 334.242 101.219 334.242 110.353C334.242 119.486 341.654 126.89 350.796 126.89Z",
    fill: "#0B5364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.796 110.353L239.519 237.957",
    stroke: "#0B5364",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.529 170.48C310.044 170.48 313.704 166.824 313.704 162.313C313.704 157.803 310.044 154.146 305.529 154.146C301.014 154.146 297.354 157.803 297.354 162.313C297.354 166.824 301.014 170.48 305.529 170.48Z",
    fill: "#33AF7C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_234_2034"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 482,
    height: 485,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrbit);
export default __webpack_public_path__ + "static/media/orbit.1287856b59e2c2c3e6a4f3635081c5b9.svg";
export { ForwardRef as ReactComponent };